import { ACCEPTED_API_ZYGOSITY_TYPES } from "../../constants/zygosity";

function processResponse(res) {
  const { samples, variants_info: variantDict } = res;
  const acceptedZyg = new Set(ACCEPTED_API_ZYGOSITY_TYPES);
  const newSamples = (samples || []).filter(Boolean).map((x) => {
    const origVariants = x.variants || [];
    const vars = origVariants
      .filter(Boolean)
      .filter((i) => variantDict[i.variant_id] && acceptedZyg.has(i.zygosity));

    vars.forEach((y) => {
      const variant = variantDict[y.variant_id];
      const inSamples = variant.inSamples || new Set();
      const sampleInfo = variant.sampleInfo || {};

      inSamples.add(x.sample_name);
      sampleInfo[x.analysis_id] = {
        coverage: y.coverage,
        zygosity: y.zygosity,
        allelicBalance: y.allelic_balance,
        phasingGroup: y.phasing_group,
      };
      variant.inSamples = inSamples;
      variant.sampleInfo = sampleInfo;
    });

    return { ...x, variants: vars };
  });

  return { ...res, variantDict, samples: newSamples };
}

export default processResponse;
